var _defs, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "66mm",
    height: "66mm",
    viewBox: "0 0 187.0866 187.0866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.bl,.bm{fill:none;}.b{opacity:0.5;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.bo,.e{fill:#ffcce8;}.f{clip-path:url(#c);}.g{clip-path:url(#d);}.h{clip-path:url(#e);}.i{clip-path:url(#f);}.j{clip-path:url(#g);}.k{clip-path:url(#i);}.l{clip-path:url(#k);}.m{clip-path:url(#l);}.n{clip-path:url(#m);}.o{clip-path:url(#n);}.p{clip-path:url(#o);}.q{clip-path:url(#q);}.r{clip-path:url(#r);}.s{clip-path:url(#s);}.t{clip-path:url(#t);}.u{clip-path:url(#u);}.v{clip-path:url(#w);}.w{clip-path:url(#x);}.x{clip-path:url(#y);}.y{clip-path:url(#z);}.z{clip-path:url(#aa);}.aa{clip-path:url(#ab);}.ab{clip-path:url(#ac);}.ac{clip-path:url(#ae);}.ad{clip-path:url(#ag);}.ae{clip-path:url(#ai);}.af{clip-path:url(#aj);}.ag{clip-path:url(#ak);}.ah{clip-path:url(#am);}.ai{clip-path:url(#ao);}.aj{clip-path:url(#aq);}.ak{clip-path:url(#ar);}.al{clip-path:url(#as);}.am{clip-path:url(#au);}.an{clip-path:url(#aw);}.ao{clip-path:url(#ay);}.ap{clip-path:url(#ba);}.aq{clip-path:url(#bc);}.ar{clip-path:url(#bd);}.as{clip-path:url(#be);}.at{clip-path:url(#bg);}.au{clip-path:url(#bh);}.av{clip-path:url(#bi);}.aw{clip-path:url(#bk);}.ax{clip-path:url(#bm);}.ay{clip-path:url(#bn);}.az{clip-path:url(#bo);}.ba{clip-path:url(#bq);}.bb{clip-path:url(#br);}.bc{clip-path:url(#bs);}.bd{clip-path:url(#bt);}.be{clip-path:url(#bu);}.bf{clip-path:url(#bv);}.bg{clip-path:url(#bw);}.bh{clip-path:url(#by);}.bi{clip-path:url(#ca);}.bj{fill:#fc86bf;stroke-width:0.4px;}.bj,.bl,.bn,.bo,.bp{stroke:#961c6d;}.bk{opacity:0.8;fill:url(#cc);}.bl{stroke-width:20px;}.bm{stroke:#ffcce8;stroke-width:13px;}.bm,.bo{stroke-miterlimit:10;}.bn{fill:#961c6d;}.bn,.bo,.bp{stroke-width:0.8382px;}.bp{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7862,
    y: 38.912,
    width: 11.1178,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7862,
    y: 38.912,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7862,
    y: 63.5973,
    width: 11.1178,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7862,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7866,
    y: 88.2825,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7866,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7857,
    y: 14.2256,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 49.1411,
    y: 38.912,
    width: 11.1186,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1562,
    y: 38.912,
    width: 11.1186,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1567,
    y: 38.912,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1713,
    y: 38.912,
    width: 11.1185,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1709,
    y: 38.912,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 49.1411,
    y: 63.5973,
    width: 11.1186,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1562,
    y: 63.5973,
    width: 11.1186,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1567,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1713,
    y: 63.5973,
    width: 11.1185,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1709,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 49.1411,
    y: 88.2825,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1563,
    y: 88.2825,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1568,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1715,
    y: 88.2825,
    width: 11.1185,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.171,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.9524,
    y: 38.912,
    width: 11.1178,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.9524,
    y: 38.912,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.0619,
    y: 38.912,
    width: 11.119,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 21.0774,
    y: 38.912,
    width: 11.119,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 35.0929,
    y: 38.912,
    width: 11.119,
    height: 24.6853
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.9524,
    y: 63.5973,
    width: 11.1178,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.9524,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.0619,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 21.0774,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 35.0929,
    y: 63.5973,
    width: 11.119,
    height: 24.6852
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.952,
    y: 88.2825,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.952,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.0623,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 21.0776,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 35.0929,
    y: 88.2825,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 49.1411,
    y: 14.2256,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1563,
    y: 14.2256,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1718,
    y: 14.2256,
    width: 11.1181,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1722,
    y: 14.2256,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.9528,
    y: 14.2256,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.063,
    y: 14.2256,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.063,
    y: 14.2256,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 21.0782,
    y: 14.2256,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 35.0929,
    y: 14.2256,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7866,
    y: -10.023,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 90.7866,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 49.1411,
    y: -10.023,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1563,
    y: -10.023,
    width: 11.1186,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 63.1568,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.1715,
    y: -10.023,
    width: 11.1185,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 77.171,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.952,
    y: -10.023,
    width: 11.1178,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -6.952,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.0623,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 21.0776,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 35.0929,
    y: -10.023,
    width: 11.119,
    height: 24.6864
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cc",
    width: 97.7386,
    height: 98.3055,
    patternTransform: "translate(-235.1293 -365.9689) rotate(-45) scale(1.091)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 97.739 98.306"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 97.7386,
    height: 98.3055
  }), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.5793,38.9116q-4.8953,7.7067-9.7941,15.4143,2.57-.1429,5.1389-.2823L91.99,63.5981q4.956-6.6843,9.9144-13.3673l-5.177-.08q1.9266-5.6208,3.8521-11.2394"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.5793,63.5978q-4.8953,7.7066-9.7941,15.4131,2.57-.1412,5.1389-.2812Q93.9564,83.5069,91.99,88.283q4.956-6.6823,9.9144-13.3661l-5.177-.08q1.9266-5.6208,3.8521-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.58,88.2828q-4.8953,7.7066-9.7941,15.4143,2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.956-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8521-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.58,14.2264Q95.6829,21.933,90.7848,29.64q2.57-.1411,5.1389-.2812-1.9678,4.7773-3.9343,9.5534,4.9578-6.6825,9.9144-13.3662l-5.1771-.08q1.9268-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M58.9354,38.9116Q54.0383,46.6183,49.14,54.3259q2.57-.1429,5.1389-.2823-1.9677,4.7772-3.9343,9.5545,4.9578-6.6843,9.9144-13.3673l-5.177-.08q1.9266-5.6208,3.8533-11.2394"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.95,38.9116q-4.8971,7.7067-9.7941,15.4143,2.5683-.1429,5.1377-.2823-1.9677,4.7772-3.9331,9.5545,4.956-6.6843,9.9132-13.3673l-5.177-.08Q71.0237,44.53,72.95,38.9116"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.9654,38.9116q-4.8971,7.7067-9.7941,15.4143,2.57-.1429,5.1377-.2823-1.9677,4.7772-3.9331,9.5545,4.956-6.6843,9.9132-13.3673l-5.177-.08q1.9266-5.6208,3.8533-11.2394"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M58.9354,63.5978Q54.0383,71.3044,49.14,79.0109q2.57-.1412,5.1389-.2812-1.9677,4.7772-3.9343,9.5533,4.9578-6.6823,9.9144-13.3661l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.95,63.5978,63.1563,79.0109q2.5683-.1412,5.1377-.2812-1.9677,4.7772-3.9331,9.5533,4.956-6.6823,9.9132-13.3661l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.9654,63.5978,77.1713,79.0109q2.57-.1412,5.1377-.2812-1.9677,4.7772-3.9331,9.5533l9.9132-13.3661-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M58.9354,88.2828q-4.8971,7.7066-9.7953,15.4143,2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.9578-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.9505,88.2828q-4.8971,7.7066-9.7941,15.4143,2.5683-.1412,5.1377-.2812-1.9677,4.7756-3.9331,9.5534,4.956-6.6843,9.9132-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.9655,88.2828q-4.8971,7.7066-9.794,15.4143,2.57-.1412,5.1377-.2812-1.9679,4.7756-3.9332,9.5534,4.956-6.6843,9.9132-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.8407,38.9116q-4.8952,7.7067-9.794,15.4143,2.57-.1429,5.1388-.2823l-3.9343,9.5545q4.956-6.6843,9.9144-13.3673l-5.177-.08Q.9152,44.53,2.8407,38.9116"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.8569,38.9116Q11.96,46.6183,7.0617,54.3259q2.57-.1429,5.1388-.2823L8.2662,63.5981q4.956-6.6843,9.9144-13.3673l-5.177-.08Q14.93,44.53,16.8569,38.9116"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ac"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M30.872,38.9116q-4.897,7.7067-9.7952,15.4143,2.57-.1429,5.1389-.2823l-3.9343,9.5545q4.9578-6.6843,9.9144-13.3673l-5.1771-.08Q28.9455,44.53,30.872,38.9116"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.8872,38.9116q-4.897,7.7067-9.7953,15.4143,2.57-.1429,5.1389-.2823l-3.9343,9.5545q4.9578-6.6843,9.9144-13.3673l-5.177-.08Q42.96,44.53,44.8872,38.9116"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("g", {
    className: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.8407,63.5978q-4.8952,7.7066-9.794,15.4131,2.57-.1412,5.1388-.2812-1.9677,4.7772-3.9343,9.5533,4.956-6.6823,9.9144-13.3661l-5.177-.08Q.9152,69.2163,2.8407,63.5978"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ag"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.8569,63.5978Q11.96,71.3044,7.0617,79.0109q2.57-.1412,5.1388-.2812-1.9677,4.7772-3.9343,9.5533,4.956-6.6823,9.9144-13.3661l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ah"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M30.872,63.5978q-4.897,7.7066-9.7952,15.4131,2.57-.1412,5.1389-.2812-1.9677,4.7772-3.9343,9.5533,4.9578-6.6823,9.9144-13.3661l-5.1771-.08q1.9268-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ai"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.8872,63.5978q-4.897,7.7066-9.7953,15.4131,2.57-.1412,5.1389-.2812-1.9677,4.7772-3.9343,9.5533,4.9578-6.6823,9.9144-13.3661l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aj"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.8411,88.2828q-4.8952,7.7066-9.7941,15.4143,2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.956-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8521-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "al"
  }, /*#__PURE__*/React.createElement("g", {
    className: "al"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.8573,88.2828Q11.96,95.9894,7.062,103.6971q2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.956-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M30.8723,88.2828q-4.897,7.7066-9.7953,15.4143,2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.9578-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "an"
  }, /*#__PURE__*/React.createElement("g", {
    className: "an"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.8872,88.2828q-4.897,7.7066-9.7953,15.4143,2.57-.1412,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.9578-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ao"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M58.935,14.2264Q54.038,21.933,49.141,29.64q2.57-.1411,5.1376-.2812-1.9677,4.7773-3.9331,9.5534,4.956-6.6825,9.9132-13.3662l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ap"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.95,14.2264Q68.0531,21.933,63.1561,29.64q2.57-.1411,5.1377-.2812-1.9661,4.7773-3.9331,9.5534,4.956-6.6825,9.9144-13.3662l-5.1783-.08q1.9267-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aq"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.9655,14.2264Q82.07,21.933,77.1714,29.64q2.57-.1411,5.1389-.2812-1.9677,4.7773-3.9343,9.5534,4.956-6.6825,9.9144-13.3662l-5.177-.08q1.9248-5.6208,3.8521-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "as"
  }, /*#__PURE__*/React.createElement("g", {
    className: "as"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.8414,14.2264Q-2.0556,21.933-6.9538,29.64q2.57-.1411,5.1389-.2812-1.9677,4.7773-3.9343,9.5534,4.9578-6.6825,9.9144-13.3662l-5.1771-.08Q.9149,19.8449,2.8414,14.2264"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "at"
  }, /*#__PURE__*/React.createElement("g", {
    className: "au"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.8569,14.2264Q11.96,21.933,7.0629,29.64q2.5682-.1411,5.1377-.2812-1.9679,4.7773-3.9343,9.5534,4.9578-6.6825,9.9143-13.3662l-5.177-.08q1.9268-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "av"
  }, /*#__PURE__*/React.createElement("g", {
    className: "av"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M30.8718,14.2264,21.0777,29.64q2.57-.1411,5.1377-.2812-1.9677,4.7773-3.9331,9.5534l9.9132-13.3662-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aw"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.8873,14.2264,35.0932,29.64q2.57-.1411,5.1377-.2812-1.9677,4.7773-3.9331,9.5534L46.211,25.5455l-5.177-.08q1.9266-5.6208,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ax"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M100.58-10.0227Q95.6845-2.3161,90.7856,5.3916q2.57-.1413,5.1389-.2812Q93.9568,9.886,91.99,14.6638q4.956-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8521-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "az"
  }, /*#__PURE__*/React.createElement("g", {
    className: "az"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M58.9354-10.0227Q54.0383-2.3161,49.14,5.3916,51.71,5.25,54.279,5.11q-1.9677,4.7756-3.9343,9.5534,4.9578-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ba"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.9505-10.0227Q68.0535-2.3161,63.1564,5.3916,65.7247,5.25,68.2941,5.11,66.3264,9.886,64.361,14.6638q4.956-6.6843,9.9132-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bc"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.9655-10.0227q-4.8971,7.7066-9.794,15.4143,2.57-.1413,5.1377-.2812Q80.3413,9.886,78.376,14.6638q4.956-6.6843,9.9132-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "be"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.8411-10.0227Q-2.0541-2.3161-6.953,5.3916q2.57-.1413,5.1389-.2812Q-3.7818,9.886-5.7484,14.6638-.7924,7.9795,4.166,1.2964l-5.177-.08Q.9156-4.4024,2.8411-10.0227"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bg"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.8573-10.0227Q11.96-2.3161,7.062,5.3916q2.57-.1413,5.1389-.2812Q10.2332,9.886,8.2666,14.6638q4.956-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bh"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M30.8723-10.0227Q25.9753-2.3161,21.077,5.3916q2.57-.1413,5.1389-.2812-1.9677,4.7756-3.9343,9.5534Q27.2394,7.9795,32.196,1.2964l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bi"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44.8872-10.0227Q39.99-2.3161,35.0919,5.3916q2.57-.1413,5.1389-.2812-1.9677,4.7756-3.9343,9.5534,4.9578-6.6843,9.9144-13.3674l-5.177-.08q1.9266-5.619,3.8533-11.2393"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "bj",
    cx: 93.5433,
    cy: 93.9259,
    r: 82.8377
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "bk",
    cx: 93.5433,
    cy: 93.9259,
    r: 82.8377
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "bl",
    cx: 93.5433,
    cy: 93.9259,
    r: 82.8377
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "bm",
    cx: 93.5433,
    cy: 93.9259,
    r: 82.8377
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M51.1454,17.3913C58.3573,49.5039,79.79,152.3182,79.79,152.3182a1.3711,1.3711,0,0,0,2.3592.6169q11.748-13.1049,23.4943-26.2105a1.3709,1.3709,0,0,1,2.2864.3877L133.43,181.8816c.5983,1.5725,2.0416,2.09,3.0453,1.5725a2.7534,2.7534,0,0,0,1.5219-2.8946c-5.402-38.2216-12.9232-74.9467-18.5848-113.1277a1.371,1.371,0,0,0-2.3105-.7832L91.44,91.5253a1.3769,1.3769,0,0,1-2.1938-.3984C76.2152,64.0611,66.5606,43.3418,53.7236,16.509c-.2991-.6253-1.3927-12.9171-2.0495-12.6955l-.7836.5034C49.707,4.97,48.9889,7.7887,51.1454,17.3913Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M51.1454,12.156C58.1486,44.4542,79.73,142.2987,79.73,142.2987a1.5127,1.5127,0,0,0,2.6027.68q11.5814-12.919,23.161-25.8387a1.5124,1.5124,0,0,1,2.5223.4277l25.9679,59.6851c.956,2.3087,3.761,1.3037,3.36-1.1823-.537-3.33-.7625-5.1213-.9484-6.3754-5.7483-38.7688-11.2132-68.8406-16.9412-107.22a1.5155,1.5155,0,0,0-2.5492-.8729l-25.3245,24.55a1.5183,1.5183,0,0,1-2.42-.4384C76.1731,58.7354,67.5675,37.4406,55.2389,10.3311c-.2869-.631-2.2814-6.8057-3.0344-6.8629l-.53.3453C49.8231,4.56,49.9253,6.5286,51.1454,12.156Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M51.1454,5.107,79.79,133.6026a1.3711,1.3711,0,0,0,2.3592.6168q11.748-13.1049,23.4943-26.2105a1.371,1.371,0,0,1,2.2864.3877l25.844,62.0278a1.3711,1.3711,0,0,0,2.6218-.7288q-8.4922-57.276-16.9841-114.5482a1.371,1.371,0,0,0-2.3105-.7832L91.44,79.2409a1.3767,1.3767,0,0,1-2.1938-.3984C76.2152,51.7767,66.5606,31.0574,53.7236,4.2246A1.3791,1.3791,0,0,0,52.0451,3.51h0A1.3706,1.3706,0,0,0,51.1454,5.107Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceLight);
export default __webpack_public_path__ + "static/media/space-LIGHT.9a51051f8f7c5b02dcb7d29fbbb68d87.svg";
export { ForwardRef as ReactComponent };